import { render, staticRenderFns } from "./JobworkReceiptView.vue?vue&type=template&id=2b4d62e8&scoped=true"
import script from "./JobworkReceiptView.vue?vue&type=script&lang=js"
export * from "./JobworkReceiptView.vue?vue&type=script&lang=js"
import style0 from "./JobworkReceiptView.vue?vue&type=style&index=0&id=2b4d62e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4d62e8",
  null
  
)

export default component.exports